/*eslint-disable no-useless-escape*/

export const MOBILE_WIDTH = 1200;
